import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DocumentService } from 'com.trumbull.phx.document.api-client';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})

export class DoumentUploadService {

  // private readonly documentUploadUrl = '/api/document/v1/internal.repo.1/content';
  
  constructor(private readonly http: HttpClient, private readonly documentService: DocumentService) {}

  // uploadDocument(payload: File | null, provider = 'standard'): Observable<any> {
  //   const url = `${this.documentUploadUrl}/${provider}`;
  //   return this.http.post<any>(this.documentUploadUrl, payload);  
  // }

  /*
  * Document Upload Service 
  */

  uploadDocument(payload: File, provider = 'internal.repo.1'): Observable<any> {
    return this.documentService.createDocumentContent(provider, payload);  
  }

}
